import React from "react";

import { useAppSelector } from "store";
import {
    selectCompetitorStoreCategories,
    toggleCompetitorStoreCategoryIsSelected
} from "modules/customer/tools/location/competitionNew/competitionSlice";

import MultiSelectFilter from "components/filters/MultiSelectFilter";

const StoreCategoriesDropdown: React.FC = () => {
    const storeCategories = useAppSelector(selectCompetitorStoreCategories);
    return (
        <MultiSelectFilter
            title="Competitor store categories"
            items={storeCategories}
            toggleItemIsSelected={toggleCompetitorStoreCategoryIsSelected}
        />
    );
};

export default StoreCategoriesDropdown;
